require([
    'flickity',
    'root/Assets/Js/Vendor/vivus',
    'base/MbiImageSize',
    // 'waypoint',
    'root/Base/Js/Vendor/PictureFill',
    'root/Base/Js/MbiImageSize',
    'root/Assets/Js/Templates',
	'root/Base/Js/Ajax',
	'jquery'
], function(
    Flickity,
    Vivus,
    mbiImageSize
    ) {
	'use strict';


    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload()
        }
    };

/*================================
=            flickity            =
================================*/

    if ($('.swiper--slider').length > 0 ) {

        var flkty = new Flickity( '.swiper--slider', {
            // options
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: false,
            imagesLoaded: true,
            autoPlay: 3000
            // watchCSS: true
        });
    }


/*==================================
=            goto anker            =
==================================*/

    $(document).on('click', '.js_goto', function(){
        var goto = $(this).attr('data-to');


        $('html, body').animate({
            scrollTop: $('[data-anker="' + goto + '"]').offset().top - 150
        }, 1000);

    });

        $('.back-to-top').click(function(){
        $('html, body').animate({scrollTop : 0},1500);
        return false;
    });

/*============================
=            ajax            =
============================*/

    $(document).on('AjaxSwapDone', function(e, data){

        // if (.hasClass('no-menu')) {
        //     $('.navigation').addClass('hide--hide');
        // } else {
        //     $('.navigation').removeClass('hide--hide');
        // }
        mbiImageSize.init();
        if ($(document).find('.swiper--slider').length > 0 ) {
//console.log("create Sldier");
            var flkty = new Flickity( '.swiper--slider', {
                // options
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: false,
                imagesLoaded: true,
                autoPlay: 3000
                // watchCSS: true
            });
        }
        window.scrollTo(0,0);

    });

/*==========================================
=            put fixed together            =
==========================================*/

/**
 * Provides requestAnimationFrame in a cross browser way.
 * @author paulirish / http://paulirish.com/
 */

if ( !window.requestAnimationFrame ) {

    window.requestAnimationFrame = ( function() {

        return window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element ) {

            window.setTimeout( callback, 1000 / 60 );

        };

    } )();

}

    var lastPosition = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    showHideLinkToOther(lastPosition);

    function showHideLinkToOther(lastPosition){

        if(lastPosition <= -500 ) {
            $('.linkToOther').removeClass('is_visible');
        } else {
            var body = document.body, html = document.documentElement;
            var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight )-$(window).height();


            if(lastPosition <= (height-400)){
                $('.linkToOther').addClass('is_visible');
            } else {
                $('.linkToOther').removeClass('is_visible');
            }
        }
    }


    var loop = function() {

        requestAnimationFrame(loop);

        var check = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

        if(lastPosition !== check) {

            lastPosition = check;

            showHideLinkToOther(lastPosition);
        }
    }
    loop();

});

/*=====================================
=            svg animation            =
=====================================*/

// var myVivus = new Vivus('la_kosmetik_web_blume-id', {
//     duration: 200,
//     start: 'manual',
// });

// $(document).on('mouseenter', '.svg--la_kosmetik_web_blume',function(){
//     console.log('mouseenter');
//     myVivus.play(1);
// });
// $(document).on('mouseleave', '.svg--la_kosmetik_web_blume',function(){
//     console.log('mouseleave');
//     myVivus.play(-1);
// });




define("Assets/Js/Footer.js", function(){});

